<template>
	<div class="agreement">
        <div class="register_top">
            <div class="logo">
                <!-- <img src="../../assets/headerLogo.svg" /> -->
            </div>
        </div>
		<div class="content">
            <div class="title">
                <strong>Terms and Conditions</strong>
            </div>
            <div class="contentText">
                <div class="middleTitle">
                  1. Acceptance of Terms
                </div>
                <div>
                    By accessing or using the services provided by TAROKO SA DE CV, you agree to comply with these Terms and Conditions.
                </div>
                <div>
                    If you do not agree, you may not use the platform.
                </div>
                <div class="middleTitle">
                    2. Services
                </div>
                <div>
                    TAROKO S.A DE C.V provides:
                </div>
                <div>
                    Data management solutions
                </div>
                <div>
                    Data labeling and annotation services
                </div>
                <div>
                    Workflow automation tools
                </div>
                <div>
                    AI data set preparation tools
                </div>
                <div>
                    Task distribution and management for labeling teams
                </div>
                <div class="middleTitle">
                    Services may be provided through:
                </div>
                <div>
                    Web-based platform
                </div>
                <div>
                   APIs
                </div>
                <div>
                    Managed services 
                </div>
                <div class="middleTitle">
                    3. Account Registration
                </div>
                <div>
                    Users must:
                </div>
                <div>
                    Provide accurate information
                </div>
                <div>
                    Maintain confidentiality of account credentials
                </div>
                <div>
                Be responsible for activities under their account
                </div>
                <div>
                The Company reserves the right to suspend accounts involved in misuse or illegal activity.
                </div>
                <div class="middleTitle">
                4. Client Data Ownership
                </div>
                <div>
                Clients retain full ownership of data uploaded to the platform.
                </div>
                <div>
                The Company receives a limited license to process such data solely to provide the services.
                </div>
                <div>
                Clients must ensure they have legal rights to upload and process the data.
                </div>
                <div class="middleTitle">
                5. Acceptable Use
                </div>
                <div>
                Users may not:
                </div>
                <div>
                Upload unlawful data
                </div>
                <div>
                Upload copyrighted content without authorization
                </div>
                <div>
                Attempt to hack or disrupt the platform
                </div>
                <div>
                Use the platform for illegal activities
                </div>
                
                <div>
                   Violation may result in account termination.
                </div>
                <div class="middleTitle">
                    6. Payment Terms
                </div>
                <div>
                    Services may be billed through:
                </div>
                <div>
                    Subscription plans
                </div>
                <div>
                    Usage-based pricing
                </div>
                <div>
                    Project-based pricing
                </div>
                <div>
                   Invoices must be paid within the specified payment period.
                </div>
                <div>
                    Failure to pay may result in suspension of services. 
                </div>
								<div class="middleTitle">
								    7. Payment Processing
								</div>
								<div>
								    Users acknowledge that the payment is processed by Openpay only as a payment processor and is not responsible for the delivery of the goods or service.
								</div>
                <div class="middleTitle">
                    8. Confidentiality
                </div>
                <div>
                    Both parties agree to keep confidential any proprietary information shared during the course of the service.
                </div>
                <div class="middleTitle">
                    9. Service Availability
                </div>
                <div>
                  We strive to maintain high service availability but do not guarantee uninterrupted access.
                </div>
                <div>
                    Maintenance, updates, or unforeseen outages may occur.
                </div>
                <div class="middleTitle">
                  10. Limitation of Liability
                </div>
                <div>
                    To the maximum extent permitted by law:
                </div>
                <div>
                    The Company shall not be liable for indirect or consequential damages.
                </div>
                <div>
                    Liability is limited to the amount paid by the client in the preceding 12 months.
                </div>
                <div class="middleTitle">
                    11. Termination
                </div>
                <div>
                   We may terminate accounts for:
                </div>
                <div>
                    Violation of terms
                </div>
                <div>
                    Non-payment
                </div>
                <div>
                    Security risks
                </div>
                <div>
                    Users may terminate their accounts at any time by contacting support.
                </div>
                <div class="middleTitle">
                    12. Governing Law
                </div>
                <div>
                    These Terms shall be governed by the laws of Mexico.
                </div>
                <div class="middleTitle">
                    13. Dispute Resolution
                </div>
                <div>
                    Disputes shall first be resolved through negotiation. If unresolved, disputes shall be submitted to the competent courts in Mexico.
                </div>
                <div class="middleTitle"> 
                    14. Contact
                </div>
                <div>
                    Email: tarokoservice@outlook.com
                </div>
                
            </div>
		</div>

	</div>
</template>

<script>

	export default {
		data() {
			return {
            
			}
		},
		mounted() {
			
		},
		methods: {
			

		},
		computed: {
		},

	}
</script>

<style lang="less" scoped>
	.middleTitle{
		font-weight: bold;
	}
	.agreement {
		background-color: #FFF;
        width: 100%;
        padding-bottom: 120px;
        .register_top{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 12px 90px 8px 90px;
            background-color: #0D2436;
            .logo{
							min-height: 42px;
                img{
                    width: 210px;
                    height: 42px;
                }
            }
        }
        .content{
            height: calc(100% - 130px);
            width: 70%;
            margin: 0 auto;
            font-family: HarmonyOS_Sans_SC;
            font-size: 14px;
            color: #131523;
            text-align: left;
            font-style: normal;
            .title{
                margin-top: 48px;
                margin-bottom: 24px;
                font-family: HarmonyOS_Sans_SC_Bold;
                font-size: 24px;
                color: #131523;
                text-transform: none;
            }
            .contentText{
                padding: 8px 28px;
                border-radius: 10px;
                border: 1px solid #E2E8F0;
                div{
                    margin: 20px 0;
                }
            }
        }
	}

</style>


// WEBPACK FOOTER //
// src/page/index/userAgreement.vue